export default __webpack_public_path__ + "static/media/drep1.b9281126.JPG";